import type { RouteRecordRaw } from 'vue-router';
export const routes: RouteRecordRaw[] = [
  {
    path: 'special-events',
    meta: {
      layoutFeatures: {
        actionPanel: true,
      },
    },
    component: () => import('@/app/modules/special-events/views/special-events-demo.vue'),
  },
];
export default routes;
